import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import Rating from 'components/atoms/Rating';
import SwiperCore, { Autoplay } from 'swiper';
import { useTranslation } from 'react-i18next';
const Feedback = () => {
  const { t } = useTranslation('header');
  SwiperCore.use([Autoplay]);
  return (
    <div
      id="feedback"
      className="bg-[url('./../../assets/images/img-feedback.png')] bg-no-repeat bg-cover px-4 py-12 xl:py-[60px] mt-9 xl:mt-[130px]"
    >
      <h4 className="font-dancing-script text-center text-white text-[16px] xl:text-[24px] font-bold">
        {t('feedback.titleMain')}
      </h4>
      <h2 className="text-center text-white text-[24px] xl:text-[32px] font-bold xl:font-extrabold w-[60%] xl:w-full m-auto">
        {t('feedback.feedbackUser')}
      </h2>

      <div className="mt-6">
        <Swiper slidesPerView={1} pagination={true} modules={[Pagination]} autoplay>
          <SwiperSlide>
            <div className="flex flex-col items-center gap-y-2 xl:w-[60%] m-auto pb-[34px]">
              <Rating />
              <p className="text-blue-50 text-[14px] leading-[20px] text-center">
                {t('feedback.title1')}
              </p>
              <h5 className="font-medium leading-[22px] italic text-white">
                {t('feedback.user1')}
              </h5>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center gap-y-2 xl:w-[60%] m-auto pb-[34px]">
              <Rating />
              <p className="text-blue-50 text-[14px] leading-[20px] text-center">
                {t('feedback.title2')}
              </p>
              <h5 className="font-medium leading-[22px] italic text-white">
                {t('feedback.user2')}
              </h5>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center gap-y-2 xl:w-[60%] m-auto pb-[34px]">
              <Rating />
              <p className="text-blue-50 text-[14px] leading-[20px] text-center">
                {t('feedback.title3')}
              </p>
              <h5 className="font-medium leading-[22px] italic text-white">
                {t('feedback.user3')}
              </h5>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center gap-y-2 xl:w-[60%] m-auto pb-[34px]">
              <Rating />
              <p className="text-blue-50 text-[14px] leading-[20px] text-center">
                {t('feedback.title4')}
              </p>
              <h5 className="font-medium leading-[22px] italic text-white">
                {t('feedback.user4')}
              </h5>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex flex-col items-center gap-y-2 xl:w-[60%] m-auto pb-[34px]">
              <Rating />
              <p className="text-blue-50 text-[14px] leading-[20px] text-center">
                {t('feedback.title5')}
              </p>
              <h5 className="font-medium leading-[22px] italic text-white">
                {t('feedback.user5')}
              </h5>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Feedback;
